module.exports = __webpack_public_path__ + "assets/pace-desktop.5f7f4e1a0dd96047da678a84b6a32bd0.png";